<div class="container" style="height:auto;width:auto;">
  Status Filter:
  <span class="d-block"><input type="checkbox" id="showAll" [checked]="showAll" (change)="showAll = !showAll; onChange($event)" />Show All</span>
  <span class="d-block"><input type="checkbox" id="active" [checked]="active" (change)="active = !active; onChange($event)" />Active</span>
  <span class="d-block"><input type="checkbox" id="inactive" [checked]="inactive" (change)="inactive = !inactive; onChange($event)" />Inactive</span>
</div>
